import React from 'react';

const ProgressBar = (props) => {
  const { percentage } = props;
  const progressStyle = {
    width: `${percentage}%`
  };

  return <div className='progress-container'>
    <div className='progress-bar-wrapper'>
      <div className='progress-bar'>
        <div className='progress-level' style={progressStyle}></div>
      </div>
    </div>
  </div>;
};

ProgressBar.defaultProps = {
  percentage: 0
};

export default ProgressBar;

